import { render } from "./orthopedic_investigations.vue?vue&type=template&id=8d62f288&scoped=true"
import script from "./orthopedic_investigations.vue?vue&type=script&lang=js"
export * from "./orthopedic_investigations.vue?vue&type=script&lang=js"

import "./orthopedic_investigations.vue?vue&type=style&index=0&id=8d62f288&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d62f288"]])

export default __exports__